import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { sethidemenu } from '../../actions/actions';

const MaskAnimation = (props) => {
    const [isAnimating, setIsAnimating] = useState(true);

    useEffect(() => {
        props.dispatch(sethidemenu(true)); // Ensure the menu is visible during the animation
        const timer = setTimeout(() => {
            setIsAnimating(false);
        }, 1000); // Adjust the duration to match the animation in CSS
        return () => clearTimeout(timer);
    }, []);
    const [disappear, setDisappear] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setDisappear(true);
            props.dispatch(sethidemenu(false)); // Hide the menu after the animation
        }, 2000); // Adjust the duration to match the animation in CSS
        return () => clearTimeout(timer);
    }, []);
    
    if(disappear) {
        return null; // Return null to hide the component after the animation
    }

    return (
        <div className='fixed top-0 left-0 w-full h-full z-[999]'>
            <div className={`mask ${isAnimating ? 'mask-animate' : ''}`}></div>
            <div className={`mask-curtain ${isAnimating ? 'mask-curtain-animate' : ''}`}/>
        </div>
    );
};

export default connect((store)=>{
    return{
      control:store.controlReducer,
    }
  })(MaskAnimation)
